export default "__VITE_PUBLIC_ASSET__837d70b2__"